export default function Gold() {
    return (
        <>
            <p>Gold is an abstract measurement of how much wealth a
                character has, and is measured in handfuls, bags, and chests,
                with 10 handfuls to 1 bag, and 10 bags to 1 chest. When you
                have marked all of the slots in a category and you gain another
                gold reward in that category, mark a slot in the following
                category and clear all the slots in the current one.
                For example, if you have 9 handfuls and gain another, you
                instead mark 1 bag and erase all handfuls. If you have 9 bags
                and gain another, you mark 1 chest and erase all bags.
                You can’t have more than 1 chest, so if all your Gold slots are
                marked, you’ll need to spend some of your gold or store it
                somewhere else before you can acquire more.</p>
        </>
    );
}